import type { Asset } from '@/types/dashboard-types'
import { DATA_SOURCE_VALUES, type DataSource } from '@/types/data-source'

/**
 * Builds an asset dropdown label, e.g. `131025: Carrier: Advanced/X4 7500`.
 *
 * Make and model come from the reefer, not the asset — Timescale splits them across
 * reefer/reefer_type, and Fresh keeps them on fridgetype.
 *
 * Fresh stores a literal "Unknown" model against a known make, so those are dropped and the
 * label reads `131025: Carrier: Advanced` rather than `.../Unknown`. Timescale keeps them:
 * its reefer types are all the "unknown" placeholder until the ingest starts classifying
 * them, and hiding that would make the label look broken rather than un-ingested. Once
 * classification lands this special case can go and both back ends share one rule.
 */
export const assetDropdownLabel = (asset: Asset, dataSource?: DataSource): string => {
  const parts = [asset.fridgeType?.make, asset.fridgeType?.model].filter(
    (part): part is string => typeof part === 'string' && part.trim() !== ''
  )
  const shown = dataSource === DATA_SOURCE_VALUES.timescale ? parts : parts.filter((part) => !/unknown/i.test(part))

  return shown.length ? `${asset.name}: ${shown.join('/')}` : asset.name
}
